export default "/images/heart-icon.png?aa3d8cb565a1c45b3ae3b93ac5f07036";